import { SxProps, Theme } from "@mui/material";

export type DashboardColor = "primary" | "info" | "success" | "warning" | "error" | "dark";

export const pulseSx = (isRefreshing: boolean): SxProps<Theme> => ({
  animation: isRefreshing ? "operationalPulse 1.4s ease-in-out infinite" : "none",
  "@keyframes operationalPulse": {
    "0%, 100%": { opacity: 1 },
    "50%": { opacity: 0.55 },
  },
});

export const surfaceCardSx = (accent?: DashboardColor): SxProps<Theme> => ({
  height: "100%",
  overflow: "hidden",
  position: "relative",
  borderRadius: "1rem",
  transition: "transform 260ms ease, box-shadow 260ms ease",
  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: (theme: Theme) => theme.shadows[10],
  },
  ...(accent
    ? {
        "&::before": {
          content: '""',
          position: "absolute",
          insetInline: 0,
          top: 0,
          height: "3px",
          background: (theme: Theme) =>
            `linear-gradient(90deg, ${
              (theme.palette as any)[accent]?.main ?? theme.palette.primary.main
            }, transparent)`,
        },
      }
    : {}),
  "@media (prefers-reduced-motion: reduce)": {
    transition: "none",
    "&:hover": { transform: "none" },
  },
});

export const staggerDelay = (index: number): string => `${Math.min(index, 8) * 70}ms`;
